<template>
	<v-dialog
			:value="isNoteDialog"
			content-class="dialogWrapper"
			persistent
			width="340"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>{{ titleDialog }}</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="groupField_wrap">
					<field
							:class-error="$v.comment && $v.comment.$error"
							margin="0"
							label="Note"
							placeholder="Enter note"
							@updateInput="onInput"
							:setInputValue="comment"
							is-required
							is-textarea
					></field>
				</div>
			</div>
			<div class="dialogFooter">
				<div class="buttonGroups">
					<custom-btn
							margin="0"
							text="CANCEL"
							custom-class="cancel"
							@updateEvent="onClose"
					></custom-btn>
					<custom-btn
							margin="0"
							text="save"
							custom-class="apply"
							@updateEvent="onSave"
					></custom-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "NoteDialog",
	mixins: [ validationMixin ],
	props: {
		activeItem: Object,
	},
	validations: {
		comment: { required },
	},
	data: () => ({
		isNoteDialog: true,
		titleDialog: 'Add new note',
		comment: null
	}),
	methods: {
		onInput({ value }) {
			this.comment = value;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { comment } = this.$data;
				this.$emit('updateSave', { comment }, this.activeItem);
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
	},
	mounted() {
		if (this.activeItem) {
			const { comment } = this.activeItem;
			this.comment = comment;
			this.titleDialog = 'Edit note';
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../dialog";
</style>
